import React from 'react';
import ReactDOM from 'react-dom';
import InteriorApp from "./components/InteriorApp";

const fields = document.getElementsByTagName('input');
const damagesRegex = new RegExp(/\[interior_damages\]/);
let damages, damagesFieldName;
for (let i in fields) {
  if (damagesRegex.test(fields[i].name)) {
    damages = fields[i].value;
    damagesFieldName = fields[i].name;
  }
}

if (damages !== '') {
  damages = JSON.parse(damages);
} else {
  damages = null;
}
ReactDOM.render(
  <InteriorApp damages={damages} damagesInputName={damagesFieldName} />,
  document.getElementById('interior-app')
);
